import { Engine } from "@spi/Engine/Engine";
import { toRadian } from "@spi/Common/Math";
import { vec3 } from "gl-matrix";

export function initializeGameActions(engine: Engine) {
    let moveSpeed = 0.5;
    let lookSpeed = 2;
    let rotationSpeed = 2;
    let gameActions: { [key: string]: () => void } = {};

    gameActions['Movement.GoUp'] = () => {
        var viewPort = engine.activeScene.viewPort;
        viewPort.z += moveSpeed;
    };

    gameActions['Movement.GoDown'] = () => {
        var viewPort = engine.activeScene.viewPort;
        viewPort.z -= moveSpeed;
    };

    gameActions['Movement.Accelerate'] = () => {
        moveSpeed += 0.05;
        if (moveSpeed > 4) {
            moveSpeed = 4;
        }
    };

    gameActions['Movement.Decelerate'] = () => {
        moveSpeed -= 0.05;
        if (moveSpeed < 0.4) {
            moveSpeed = 0.4;
        }
    };

    gameActions['Movement.Forward'] = () => {
        var viewPort = engine.activeScene.viewPort;
        viewPort.x -= Math.sin(toRadian(viewPort.rotation)) * moveSpeed;
        viewPort.y -= Math.cos(toRadian(viewPort.rotation)) * moveSpeed;
    };
    gameActions['Movement.Backward'] = () => {
        var viewPort = engine.activeScene.viewPort;
        viewPort.x += Math.sin(toRadian(viewPort.rotation)) * moveSpeed;
        viewPort.y += Math.cos(toRadian(viewPort.rotation)) * moveSpeed;
    };
    gameActions['Movement.Left'] = () => {
        var viewPort = engine.activeScene.viewPort;
        viewPort.rotation -= rotationSpeed;
    };
    gameActions['Movement.Right'] = () => {
        var viewPort = engine.activeScene.viewPort;
        viewPort.rotation += rotationSpeed;
    };
    gameActions['Movement.LookUp'] = () => {
        var viewPort = engine.activeScene.viewPort;
        viewPort.lookDirection -= lookSpeed;
    };
    gameActions['Movement.LookDown'] = () => {
        var viewPort = engine.activeScene.viewPort;
        viewPort.lookDirection += lookSpeed;
    };
    gameActions['Object.Rotate'] = () => {
        engine.activeScene.objectManager.iterate('main', function (obj) {
            //if (obj.selected) {
            //    obj.rotation += 1;
            //}
        });
    };


    var lightValue = 0.6;
    gameActions['Light.ToggleAmbient'] = function () {
        lightValue += 0.01;
        if (lightValue > 1) {
            lightValue = 0.0;
        }
        engine.activeScene.lightManager.ambientColor = vec3.fromValues(lightValue, lightValue, lightValue);
    };

    return gameActions;
};